import React, { Component } from 'react'
import { v1 } from 'uuid';
import Upload from '../Upload'

const PictureUpload = props => {
  const label = props?.label || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8008D', '上传图片', undefined, {returnStr: true, placement: 'top'});
  const maxSize = props?.maxSize || 102400
  const defaultParams = {
    label,
    maxSize
  }
  const randomId = v1();
  const uploadPicId = `yb-upload-img-${props.alias}-${props.value || randomId}`
  return (<Upload fileType={6} uploadPicId={uploadPicId} {...defaultParams} {...props} />)
}
export default PictureUpload